
import {

  FETCH_SUPPLIER_REQUEST,
  FETCH_SUPPLIER_SUCCESS,
  FETCH_SUPPLIER_FAILURE,

  CREATE_SUPPLIER_REQUEST,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,

  UPDATE_SUPPLIER_REQUEST,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAILURE,

  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
} from "./supplierActionType";

const initialState = {
  SupplierData: [],
  loading: false,
  error: null,
};

const supplierReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_SUPPLIER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        SupplierData: action.payload,
      };
    case FETCH_SUPPLIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        SupplierData: [],
      };

    case CREATE_SUPPLIER_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        SupplierData: action.payload,
      };
    case CREATE_SUPPLIER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SUPPLIER_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        SupplierData: action.payload,
      };
    case UPDATE_SUPPLIER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SUPPLIER_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        SupplierData: action.payload,
      };
    case DELETE_SUPPLIER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default supplierReducer;
